import { render, staticRenderFns } from "./InformationHeader.vue?vue&type=template&id=59324064&scoped=true"
import script from "./InformationHeader.vue?vue&type=script&lang=js"
export * from "./InformationHeader.vue?vue&type=script&lang=js"
import style0 from "./InformationHeader.vue?vue&type=style&index=0&id=59324064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59324064",
  null
  
)

export default component.exports